import { render, staticRenderFns } from "./DescriptionModal.vue?vue&type=template&id=63372086&"
import script from "./DescriptionModal.vue?vue&type=script&lang=js&"
export * from "./DescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "../less/descriptionModal.less?vue&type=style&index=0&module=%24&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["../less/descriptionModal.less?vue&type=style&index=0&module=%24&lang=css&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("../less/descriptionModal.less?vue&type=style&index=0&module=%24&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("63372086")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63372086')) {
      api.createRecord('63372086', component.options)
    } else {
      api.reload('63372086', component.options)
    }
    module.hot.accept("./DescriptionModal.vue?vue&type=template&id=63372086&", function () {
      api.rerender('63372086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/overview/components/DescriptionModal.vue"
export default component.exports